import React from 'react';
import { Alert } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { useUnitContext } from '../context/UnitContext';

const messages = {
  '/marketing': 'As páginas públicas, ofertas e cupons são compartilhados pela organização. Para direcionar novos leads a uma filial, use o link de Captação por unidade no CRM.',
  '/pessoal': 'O cadastro de cada funcionário é compartilhado com suas unidades autorizadas. A unidade responsável pela folha é configurada separadamente em Organização e unidades.',
  '/perfis': 'Os perfis e suas permissões são compartilhados pela organização. O acesso às unidades de cada funcionário é definido em Organização e unidades.',
  '/servicos': 'Os serviços, seus valores e materiais previstos são compartilhados pela organização. O consumo utiliza o estoque da unidade de trabalho.',
  '/configuracoes': 'Os dados gerais da empresa, convênios e horários são compartilhados pela organização. As configurações do CRM identificadas por unidade seguem a unidade de trabalho.',
};

export default function UnitDataScopeNotice() {
  const context = useUnitContext();
  const { pathname } = useLocation();
  const message = messages[pathname.replace(/\/$/, '')];
  if (!context?.multiunit || !message) return null;
  return <Alert variant="info" className="mx-3 mt-3 mb-0"><strong>Cadastro da organização.</strong> {message}</Alert>;
}
